import { render, staticRenderFns } from "./Numpad.vue?vue&type=template&id=5fee1020&scoped=true"
import script from "./Numpad.vue?vue&type=script&lang=ts"
export * from "./Numpad.vue?vue&type=script&lang=ts"
import style0 from "./Numpad.vue?vue&type=style&index=0&id=5fee1020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee1020",
  null
  
)

export default component.exports